'use client';

import { cn } from '@workspace/lib';
import { useAskGregSection } from './useAskGregSection';
import { AskGregSectionProps } from './ask-greg-section.types';
import { AskGregPromptList, AskGregSectionButton, AskGregSectionHeader } from './ui';

export function AskGregSection({ ...props }: AskGregSectionProps) {
  const {
    title,
    subtitle,
    description,
    quickPromptsTitle,
    quickPrompts,
    isShowButton,
    backgroundColorClass,
    handleAskGregClick,
    handlePromptClick,
  } = useAskGregSection(props);

  return (
    <section className={cn(backgroundColorClass, 'w-full')}>
      <div className="porta-container px-md lg:px-4xl py-xl lg:py-3xl">
        <div className={cn('gap-2xl lg:gap-4xl flex flex-col lg:flex-row lg:items-center')}>
          {/* Left Side */}
          <div className={cn('w-full lg:flex-1 gap-lg flex flex-col items-start')}>
            <AskGregSectionHeader title={title} subtitle={subtitle} description={description} />

            {isShowButton && <AskGregSectionButton onClick={handleAskGregClick} />}
          </div>

          {/* Right Side */}
          <AskGregPromptList
            quickPromptsTitle={quickPromptsTitle}
            quickPrompts={quickPrompts}
            onPromptClick={handlePromptClick}
          />
        </div>
      </div>
    </section>
  );
}
